import { PropSearch } from '../interfaces/search.interace';

export const initialStateSearch: PropSearch = {
	search: '',
};
